import api from "../config/api";
import { SubModule } from "../types/SubModule";

const API_URL = "/subModule";

export const getSubModules = () =>
  api.get(`${API_URL}/`).then((res) => res.data.data);

export const getSubModuleById = (id: number) => api.get(`${API_URL}/?id=${id}`);

export const getSubModuleByPojectId = (projectId: number) =>
  api.get(`${API_URL}/?projectId=${projectId}`);

export const createSubModule = (data: SubModule) =>
  api.post(`${API_URL}/`, data);

export const updateSubModule = (id: number, data: SubModule) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const deleteSubModule = (id: number) =>
  api.delete(`${API_URL}/?id=${id}`);
